// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--TxRNO";
export var footerContent = "styles-module--footerContent--ayBnh";
export var smallCaps = "styles-module--smallCaps--muurl";